export type TLanguage = 'en' | 'ru' | 'hy'

export const translations: Record<string, Record<TLanguage, string>> ={
    'Teacher': {
        'en':'Teacher',
        'ru':'Преподаватель',
        'hy':'Դասախոս',
    },
    'Room':{
        'en':'Room',
        'ru':'Аудитория',
        'hy':'Լսարան',
    },
    'Building':{
        'en':'Building',
        'ru':'Корпус',
        'hy':'Մասնաշենք',
    },
    'Monday':{
        'en':'Monday',
        'ru':'Понедельник',
        'hy':'Երկուշաբթի',
    },
    'Tuesday':{
        'en':'Tuesday',
        'ru':'Вторник',
        'hy':'Երեքշաբթի',
    },
    'Wednesday':{
        'en':'Wednesday',
        'ru':'Среда',
        'hy':'Չորեքշաբթի',
    },
    'Thursday':{
        'en':'Thursday',
        'ru':'Четверг',
        'hy':'Հինգշաբթի',
    },
    'Friday':{
        'en':'Friday',
        'ru':'Пятница',
        'hy':'Ուրբաթ',
    },
    'Schedule':{
        'en':'Schedule',
        'ru':'Расписание',
        'hy':'Դասացուցակ',
    },
    'Current Week':{
        'en':'Current Week',
        'ru':'Текущая неделя',
        'hy':'Այս շաբաթ',
    },
    'Next Week':{
        'en':'Next Week',
        'ru':'Следущая неделя',
        'hy':'Հաջորդ շաբաթ',
    },
    'Select a Group':{
        'en':'Select a Group',
        'ru':'Выберите Группу',
        'hy':'Ընտրեք Խումբը',
    },
    'Group':{
        'en':'Group',
        'ru':'Группа',
        'hy':'Խումբ',
    },
    'Type':{
        'en':'Type',
        'ru':'Тип',
        'hy':'Տեսակ',
    },
    'Lecture':{
        'en':'Lecture',
        'ru':'Лекция',
        'hy':'Դասախոսություն',
    },
    'Practical':{
        'en':'Practical',
        'ru':'Практика',
        'hy':'Գործնական',
    },
    'Laboratory':{
        'en':'Laboratory',
        'ru':'Лабораторная',
        'hy':'Լաբորատոր',
    },
    'CourseWork':{
        'en':'Course Work',
        'ru':'Курсовая работа',
        'hy':'Կուրսային աշխատանք',
    },
    'Lab':{
        'en':'Laboratory',
        'ru':'Лабораторная',
        'hy':'Լաբորատոր',
    },
    'Timezone':{
        'en':'Time is displayed with Asia/Yerevan timezone',
        'ru':'Время отображается с учетом часового пояса Азия/Ереван',
        'hy':'Ժամանակը ցուցադրվում է Երևանի ժամային գոտիով',
    }

}
